module.exports = __webpack_public_path__ + "img/tilda-white.7eb1e2f7.svg";